var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeletal__loader",style:({ height: ((Math.floor(Math.random() * 250 + 100)) + "px") })},[_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }